import * as React from 'react';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
// @ts-ignore
import TargetByStudentIdNull from './TargetByStudentIdNull';
// @ts-ignore
import TargetByStudentIdSelectPage from './TargetByStudentIdSelectPage';
// @ts-ignore
import TargetByStudentIdUploadPage from './TargetByStudentIdUploadPage';
import { ComposerOrganization } from 'types/typescript/messagingTypes';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

import { TargetByStudentIdPages } from './SelectRecipientPanel';

type Props = {
  onContinue: () => void,
  onPageChange: (page: TargetByStudentIdPages) => void,
  studentIdListRecipientInSelection?: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity,

  // graphql data from container
  loading: boolean,
  schools?: ComposerOrganization[],

  selectStudentIdListRecipient: (recipient: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity) => void,
  clearSelection: () => void,
};

type State = {
  showNullState: boolean,
  studentIdListUuid?: string,
  csvName?: string,
  selectedSchoolUuid: string,
};

class TargetByStudentIdPanel extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showNullState: false,
      studentIdListUuid:
        props.studentIdListRecipientInSelection &&
        props.studentIdListRecipientInSelection.recipient.uuid,
      csvName:
        props.studentIdListRecipientInSelection &&
        props.studentIdListRecipientInSelection.content.title,
      selectedSchoolUuid: '',
    };
  }

  componentDidMount() {
    const { schools, studentIdListRecipientInSelection } = this.props;
    if (
      schools &&
      !this.schoolsHaveEnoughStudentIds(schools) &&
      !studentIdListRecipientInSelection
    ) {
      this.showNullState();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (
      !prevProps.schools &&
      this.props.schools &&
      !this.schoolsHaveEnoughStudentIds(this.props.schools) &&
      !this.props.studentIdListRecipientInSelection
    ) {
      this.showNullState();
    }
  }

  showNullState = () => {
    this.setState({ showNullState: true });
  };

  hideNullState = () => {
    this.setState({ showNullState: false });
  };

  schoolsHaveEnoughStudentIds = (schools: ComposerOrganization[]) => {
    return schools.length ? schools.some(school => school.studentIdPercentage > 0.5) : false;
  };

  addListToSelection = (studentIdList: any, csvName: string) => {
    this.props.selectStudentIdListRecipient({
      __typename: 'ComposerRecipientListEntity',
      content: {
        __typename: 'ThreeLineAvatarContent',
        title: csvName,
        info: null,
        note: null,
        avatar: {
          __typename: 'UserInitialsAvatar',
          initials: 'ID',
          reachabilityStatus: null,
        },
      },
      recipient: {
        __typename: 'ComposerRecipient',
        uuid: studentIdList.uuid,
        type: 'student_id_list',
        hasLimitedSendFunctionality: false,
        filters: null,
      },
    });
  };

  handleContinue = (studentIdList: any, csvName: string) => {
    this.addListToSelection(studentIdList, csvName);
    this.props.onContinue();
  };

  handleBack = () => {
    this.props.clearSelection();
    this.setState({
      csvName: undefined,
      studentIdListUuid: undefined,
    });
  };

  handleOrgSelection = (selectedSchoolUuid: string) => {
    this.setState({ selectedSchoolUuid });
  };

  handleUploadSuccess = (data: { studentIdListUuid: string, csvName: string }) => {
    this.setState({ studentIdListUuid: data.studentIdListUuid, csvName: data.csvName });
  };

  render() {
    if (this.props.loading) {
      return <CenteredLoadingIndicator />;
    }

    const { showNullState, studentIdListUuid, csvName, selectedSchoolUuid } = this.state;

    if (showNullState) {
      return (
        <TargetByStudentIdNull
          data-test="null-page"
          onContinue={this.hideNullState}
          onMount={() => this.props.onPageChange('upload_list_null')}
        />
      );
    }

    return studentIdListUuid && csvName ? (
      <TargetByStudentIdSelectPage
        data-test="select-page"
        onContinue={this.handleContinue}
        onBack={this.handleBack}
        orgUuid={selectedSchoolUuid}
        studentIdListUuid={studentIdListUuid}
        csvName={csvName}
        onMount={() => this.props.onPageChange('list_of_uploaded_users')}
      />
    ) : (
      <TargetByStudentIdUploadPage
        data-test="upload-page"
        schools={this.props.schools}
        onUploadSuccess={this.handleUploadSuccess}
        onOrgSelection={this.handleOrgSelection}
        selectedSchoolUuid={this.state.selectedSchoolUuid}
        onMount={() => this.props.onPageChange('upload_list')}
      />
    );
  }
}

export default TargetByStudentIdPanel;
